/* ============================================================
   Incognito Coffee - Brew Log / Fisa de cupping (SCA 100 pct)
   Reteta sincronizata LIVE din calculator; scor SCA pe 100.
   Se activeaza DOAR pe pagina calculatorului (guard pe valCoffee).
   ============================================================ */
(function () {
  'use strict';

  var STORE_KEY = 'ic_brewlog_v2';
  var QUOTE = String.fromCharCode(34);

  var ATTRS = [
    ['aroma', 'Aroma', 'Cum miroase - uscat si dupa ce torni apa.'],
    ['flavor', 'Gust', 'Caracterul principal: fructe, ciocolata, flori.'],
    ['aftertaste', 'Aftertaste', 'Cat de placut si lung ramane gustul.'],
    ['acidity', 'Aciditate', 'Vie si placuta, nu acra sau inteptatoare.'],
    ['body', 'Corp', 'Senzatia in gura: usor, catifelat, dens.'],
    ['balance', 'Balans', 'Cat de bine se leaga toate intre ele.'],
    ['overall', 'General', 'Impresia ta de ansamblu.']
  ];
  var CUPATTRS = [
    ['uniformity', 'Uniformitate', 'Cestile au gust la fel?'],
    ['clean', 'Clean cup', 'Fara gusturi straine / off.'],
    ['sweetness', 'Dulceata', 'Dulceata naturala perceputa.']
  ];
  var CUPS = 5;

  function $(s, r) { return (r || document).querySelector(s); }
  function txt(id) { var el = document.getElementById(id); return el ? el.textContent.trim() : ''; }
  function num(s) { var v = parseFloat(String(s).replace(',', '.')); return isNaN(v) ? null : v; }
  function esc(s) {
    return String(s).split('&').join('&amp;').split('<').join('&lt;').split('>').join('&gt;').split(QUOTE).join('&#34;');
  }
  function scoreWord(v) {
    if (v >= 9) return 'exceptional';
    if (v >= 8) return 'excelent';
    if (v >= 7) return 'foarte bun';
    if (v >= 6) return 'bun';
    return '-';
  }
  function quality(total) {
    if (total >= 90) return ['Outstanding', 'q-out'];
    if (total >= 85) return ['Excellent', 'q-exc'];
    if (total >= 80) return ['Very Good - Specialty', 'q-vg'];
    return ['Sub-specialty', 'q-sub'];
  }
  function fmtScore(v) {
    var s = v.toFixed(2);
    if (s.slice(-3) === '.00') return s.slice(0, -3);
    if (s.slice(-1) === '0') return s.slice(0, -1);
    return s;
  }

  function init() {
    var wrap = $('.wrap');
    if (!wrap || !document.getElementById('valCoffee') || document.body.classList.contains('ic-has-brewlog')) return;
    document.body.classList.add('ic-has-brewlog');

    var cols = document.createElement('div'); cols.className = 'ic-cols';
    var main = document.createElement('div'); main.className = 'ic-col-main';
    while (wrap.firstChild) main.appendChild(wrap.firstChild);
    var side = document.createElement('aside'); side.className = 'ic-col-side';
    side.innerHTML = cardHTML();
    cols.appendChild(main); cols.appendChild(side);
    wrap.appendChild(cols);

    var card = $('.brewlog-card', side);

    function ratioStr() {
      var c = num(txt('valCoffee')), w = num(txt('valWater'));
      if (c && w && c > 0) { var r = Math.round((w / c) * 10) / 10; return '1:' + (r % 1 === 0 ? String(r) : r.toFixed(1)); }
      return '-';
    }
    function recipe() {
      var g = txt('valGrind'), gs = txt('valGrindStep');
      return {
        origin: txt('chipOriginName') || '-',
        method: txt('chipMethodName') || '-',
        dose: (txt('valCoffee') || '-') + ' g',
        water: (txt('valWater') || '-') + ' ml',
        ratio: ratioStr(),
        temp: (txt('valTemp') || '-') + ' °C',
        grind: (g || '-') + (gs ? ' (' + gs + ')' : ''),
        time: txt('derivedTime') || '-'
      };
    }
    function syncRecipe() {
      var r = recipe();
      Object.keys(r).forEach(function (k) { var el = $('#rec-' + k, side); if (el) el.textContent = r[k]; });
    }
    syncRecipe();
    ['valCoffee', 'valWater', 'valTemp', 'valGrind', 'valGrindStep', 'chipOriginName', 'chipMethodName', 'derivedTime'].forEach(function (id) {
      var el = document.getElementById(id);
      if (el) new MutationObserver(syncRecipe).observe(el, { childList: true, characterData: true, subtree: true });
    });

    var modeBtns = side.querySelectorAll('.bl-mode-btn');
    modeBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        modeBtns.forEach(function (x) { x.classList.remove('active'); });
        b.classList.add('active');
        var isFull = b.getAttribute('data-mode') === 'full';
        card.classList.toggle('mode-full', isFull);
        card.classList.toggle('mode-quick', !isFull);
        compute();
      });
    });

    ATTRS.forEach(function (a) {
      var r = $('#sca-' + a[0], side);
      if (r) r.addEventListener('input', function () { paintAttr(a[0]); compute(); });
    });
    side.querySelectorAll('.bl-nudge').forEach(function (b) {
      b.addEventListener('click', function () {
        var k = b.getAttribute('data-k'), d = parseFloat(b.getAttribute('data-d'));
        var r = $('#sca-' + k, side);
        var v = Math.max(6, Math.min(10, Math.round((parseFloat(r.value) + d) * 100) / 100));
        r.value = v; paintAttr(k); compute();
      });
    });
    side.querySelectorAll('.bl-cup').forEach(function (c) { c.addEventListener('change', compute); });
    ['taint', 'fault'].forEach(function (k) {
      side.querySelector('#def-' + k + '-minus').addEventListener('click', function () { stepDef(k, -1); });
      side.querySelector('#def-' + k + '-plus').addEventListener('click', function () { stepDef(k, 1); });
    });

    function paintAttr(key) {
      var r = $('#sca-' + key, side), v = parseFloat(r.value);
      $('#scaval-' + key, side).textContent = v.toFixed(2);
      $('#scaword-' + key, side).textContent = scoreWord(v);
    }
    ATTRS.forEach(function (a) { paintAttr(a[0]); });

    function defVal(k) { return parseInt($('#def-' + k + '-val', side).textContent, 10) || 0; }
    function stepDef(k, d) {
      var v = Math.max(0, Math.min(CUPS, defVal(k) + d));
      $('#def-' + k + '-val', side).textContent = v;
      compute();
    }

    function compute() {
      var full = card.classList.contains('mode-full');
      var sum = 0;
      ATTRS.forEach(function (a) { sum += parseFloat($('#sca-' + a[0], side).value); });
      var cupPts = 0, defects = 0;
      if (full) {
        CUPATTRS.forEach(function (c) {
          var checked = side.querySelectorAll('.bl-cup[data-attr=' + c[0] + ']:checked').length;
          cupPts += checked * 2;
        });
        defects = defVal('taint') * 2 + defVal('fault') * 4;
      } else {
        cupPts = 30;
      }
      var total = Math.max(0, Math.min(100, sum + cupPts - defects));
      var q = quality(total);
      $('#bl-total', side).textContent = fmtScore(total);
      var lab = $('#bl-quality', side);
      lab.textContent = q[0];
      lab.className = 'bl-quality ' + q[1];
      return total;
    }
    compute();

    $('#bl-date', side).value = new Date().toISOString().slice(0, 10);
    $('#bl-save', side).addEventListener('click', saveEntry);
    $('#bl-clear', side).addEventListener('click', resetForm);
    renderHistory();

    function collect() {
      var sca = {};
      ATTRS.forEach(function (a) { sca[a[0]] = parseFloat($('#sca-' + a[0], side).value); });
      var cups = {};
      CUPATTRS.forEach(function (c) { cups[c[0]] = side.querySelectorAll('.bl-cup[data-attr=' + c[0] + ']:checked').length * 2; });
      return {
        id: Date.now(), date: $('#bl-date', side).value,
        recipe: recipe(),
        mode: card.classList.contains('mode-full') ? 'full' : 'quick',
        sca: sca, cups: cups,
        taint: defVal('taint'), fault: defVal('fault'),
        notes: $('#bl-notes', side).value.trim(),
        fav: $('#bl-fav', side).checked,
        total: compute()
      };
    }
    function read() { try { return JSON.parse(localStorage.getItem(STORE_KEY)) || []; } catch (e) { return []; } }
    function store(a) { try { localStorage.setItem(STORE_KEY, JSON.stringify(a)); } catch (e) {} }
    function saveEntry() {
      var e = collect();
      var arr = read(); arr.unshift(e); store(arr);
      renderHistory();
      var b = $('#bl-save', side); var o = b.textContent; b.textContent = 'Salvat ' + e.total.toFixed(1);
      setTimeout(function () { b.textContent = o; }, 1400);
    }
    function resetForm() {
      ATTRS.forEach(function (a) { $('#sca-' + a[0], side).value = 7.5; paintAttr(a[0]); });
      side.querySelectorAll('.bl-cup').forEach(function (c) { c.checked = true; });
      $('#def-taint-val', side).textContent = '0'; $('#def-fault-val', side).textContent = '0';
      $('#bl-notes', side).value = ''; $('#bl-fav', side).checked = false;
      compute();
    }
    function del(id) { store(read().filter(function (e) { return e.id !== id; })); renderHistory(); }
    window.icBrewLogDelete = del;

    function renderHistory() {
      var arr = read();
      $('#bl-history-count', side).textContent = arr.length ? (arr.length + (arr.length === 1 ? ' fisa' : ' fise')) : '';
      var host = $('#bl-history-list', side);
      if (!arr.length) {
        host.innerHTML = `<div class='bl-empty'>Nicio fisa inca. Degusta, da scoruri si apasa Salveaza.</div>`;
        return;
      }
      host.innerHTML = arr.map(function (e) {
        var rc = e.recipe || {};
        var title = [rc.origin, rc.method].filter(Boolean).join(' · ') || 'Fisa';
        var meta = [e.date, rc.ratio, rc.temp].filter(Boolean).join(' · ');
        var star = e.fav ? `<span class='bl-entry-fav'>★</span> ` : '';
        var sc = (typeof e.total === 'number') ? e.total.toFixed(1) : '-';
        return `<div class='bl-entry'>`
          + `<div class='bl-entry-score'>` + sc + `</div>`
          + `<div class='bl-entry-main'>`
          + `<div class='bl-entry-title'>` + star + esc(title) + `</div>`
          + `<div class='bl-entry-meta'>` + esc(meta) + `</div>`
          + `</div>`
          + `<button class='bl-entry-del' title='Sterge' onclick='icBrewLogDelete(` + e.id + `)'>×</button>`
          + `</div>`;
      }).join('');
    }
  }

  function recRow(key, label) {
    return `<div class='bl-rec-row'><span class='bl-rec-label'>` + label + `</span><span class='bl-rec-val' id='rec-` + key + `'>-</span></div>`;
  }
  function attrRow(key, label, help) {
    return `<div class='bl-attr'>`
      + `<div class='bl-attr-head'>`
      +   `<span class='bl-attr-name'>` + label + `</span>`
      +   `<span class='bl-attr-readout'><span class='bl-attr-word' id='scaword-` + key + `'>-</span><span class='bl-attr-val' id='scaval-` + key + `'>7.50</span></span>`
      + `</div>`
      + `<div class='bl-scale-row'>`
      +   `<button type='button' class='bl-nudge' data-k='` + key + `' data-d='-0.25'>−</button>`
      +   `<input type='range' class='bl-scale' id='sca-` + key + `' min='6' max='10' step='0.25' value='7.5'>`
      +   `<button type='button' class='bl-nudge' data-k='` + key + `' data-d='0.25'>+</button>`
      + `</div>`
      + `<div class='bl-attr-help'>` + help + `</div>`
      + `</div>`;
  }

  function cardHTML() {
    var rec = recRow('origin', 'Origine') + recRow('method', 'Metoda') + recRow('dose', 'Doza') + recRow('water', 'Apa')
      + recRow('ratio', 'Raport') + recRow('temp', 'Temp') + recRow('grind', 'Macinare') + recRow('time', 'Timp');
    var attrs = ATTRS.map(function (a) { return attrRow(a[0], a[1], a[2]); }).join('');
    var cups = CUPATTRS.map(function (c) { return cupRow(c[0], c[1], c[2]); }).join('');

    return `<div class='card brewlog-card mode-quick'>`
      + `<div class='bl-head'>`
      +   `<div class='bl-kicker'>Fisa de cupping - SCA</div>`
      +   `<div class='bl-title'>Brew Log</div>`
      +   `<div class='bl-sub'>Reteta vine din calculator. Tu dai scorurile - totalul /100 se calculeaza singur.</div>`
      + `</div>`
      + `<div class='bl-hero'>`
      +   `<div class='bl-hero-num'><span id='bl-total'>82.5</span><span class='bl-hero-max'>/100</span></div>`
      +   `<div class='bl-quality q-vg' id='bl-quality'>Very Good - Specialty</div>`
      + `</div>`
      + `<div class='bl-body'>`
      +   `<div class='bl-section-label'>Reteta <span class='bl-live'>live din calculator</span></div>`
      +   `<div class='bl-recipe'>` + rec + `</div>`
      +   `<div class='bl-mode'>`
      +     `<button class='bl-mode-btn active' data-mode='quick' type='button'>Degustare rapida</button>`
      +     `<button class='bl-mode-btn' data-mode='full' type='button'>Cupping complet</button>`
      +   `</div>`
      +   `<div class='bl-section-label'>Scoruri <span class='bl-hint'>6 = bun &middot; 8 = excelent &middot; 9 = exceptional</span></div>`
      +   `<div class='bl-attrs'>` + attrs + `</div>`
      +   `<div class='bl-fullonly'>`
      +     `<div class='bl-section-label'>Pe cesti <span class='bl-hint'>bifeaza cestile bune (2 pct fiecare)</span></div>`
      +     `<div class='bl-cups'>` + cups + `</div>`
      +     `<div class='bl-section-label'>Defecte <span class='bl-hint'>cate cesti: taint -2 &middot; fault -4</span></div>`
      +     `<div class='bl-defects'>` + defRow('taint', 'Taint (usor)') + defRow('fault', 'Fault (puternic)') + `</div>`
      +   `</div>`
      +   `<div class='bl-section-label'>Note</div>`
      +   `<textarea id='bl-notes' class='bl-textarea' placeholder='Descriptori, observatii: citrice, caramel, finisaj lung...'></textarea>`
      +   `<div class='bl-meta-row'>`
      +     `<label class='bl-date-wrap'><span class='bl-label'>Data</span><input type='date' id='bl-date' class='bl-input'></label>`
      +     `<label class='bl-fav'><input type='checkbox' id='bl-fav'> Favorit</label>`
      +   `</div>`
      + `</div>`
      + `<div class='bl-actions'>`
      +   `<button class='bl-btn primary' id='bl-save' type='button'>Salveaza fisa</button>`
      +   `<button class='bl-btn' id='bl-clear' type='button'>Reset</button>`
      + `</div>`
      + `<div class='bl-history'>`
      +   `<div class='bl-history-head'><span class='bl-history-title'>Istoric</span><span class='bl-history-count' id='bl-history-count'></span></div>`
      +   `<div id='bl-history-list'></div>`
      + `</div>`
      + `<div class='bl-account'>`
      +   `<div class='bl-account-text'><strong>Istoricul e pe acest dispozitiv.</strong> Fa-ti cont ca sa-l pastrezi peste tot si sa urmaresti evolutia cafelelor. <a href='/account/register'>Creeaza cont</a></div>`
      + `</div>`
      + `</div>`;
  }
  function cupRow(key, label, help) {
    var boxes = '';
    for (var i = 1; i <= CUPS; i++) {
      boxes += `<label class='bl-cup-box'><input type='checkbox' class='bl-cup' data-attr='` + key + `' checked><span></span></label>`;
    }
    return `<div class='bl-cuprow'>`
      + `<div class='bl-cuprow-head'><span class='bl-cuprow-name'>` + label + `</span><span class='bl-cuprow-help'>` + help + `</span></div>`
      + `<div class='bl-cup-boxes'>` + boxes + `</div>`
      + `</div>`;
  }
  function defRow(key, label) {
    return `<div class='bl-def'>`
      + `<span class='bl-def-name'>` + label + `</span>`
      + `<div class='bl-def-ctrl'>`
      +   `<button class='bl-def-btn' id='def-` + key + `-minus' type='button'>−</button>`
      +   `<span class='bl-def-val' id='def-` + key + `-val'>0</span>`
      +   `<button class='bl-def-btn' id='def-` + key + `-plus' type='button'>+</button>`
      + `</div>`
      + `</div>`;
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
